import router from "./routers";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";
import { filterAsyncRouter } from "@/store/modules/permission";

NProgress.configure({ showSpinner: false }); //不显示转圈

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + "-中台管理";
  }
  NProgress.start();
  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      if (store.getters.userInfo == "") {
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch("getUser")
          .then(res => {
            // 拉取user_info
            // 动态路由，拉取菜单
            // console.log(res);
            // next();
            buildMenus(res.data.menu, next, to);
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        next();
      }
    }
  } else {
    if (to.path != "/login") {
      next("/login"); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export const buildMenus = (res, next, to) => {
  const asyncRouter = filterAsyncRouter(res);
  store.dispatch("GenerateRoutes", asyncRouter).then(() => {
    // 存储路由
    console.log(asyncRouter);
    router.addRoutes(asyncRouter); // 动态添加可访问路由表
    next({ ...to, replace: true });
  });
};
